import React, { useEffect, useState } from 'react';
import toast from "react-hot-toast";
import HttpClient from "../../../utils/HttpClient";

const ServiceAddBox = ({ CompanyTypeID, onSuccess }) => {
    const [serviceName, setServiceName] = useState("");

    const createService = async (e) => {
        e.preventDefault();
        const data = {
            companyTypeID: CompanyTypeID,
            name: serviceName,
        };
        const res = await HttpClient.requestData("add-service", "POST", data);
        if (res && res?.status) {
            setServiceName("");
            onSuccess();
            toast.success(res?.message);
        } else {
            toast.error(res?.message);
        }
    }

    return (
        <div style={{ marginTop: '10px', display: 'flex', gap: '10px', alignItems: 'center' }}>
            <input
                type="text"
                value={serviceName}
                onChange={(e) => setServiceName(e.target.value)}
                placeholder="Enter new service name"
                style={{ flexGrow: 1, padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
            />
            <button
                type='button'
                onClick={createService}
                className="svavtatvvbtnnm"
                style={{ background: '#28a745', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer' }}
            >
                Save New Service
            </button>
        </div>
    );

};

export default ServiceAddBox;